<template>
  <v-container class="justify-space-around">
    <div v-if="notifications.length > 0" class="notification-list">
      <div v-for="(notif, i) in notifications" :key="notif.id">
        <ListItem
          :noTopBorder="i === 0"
          v-if="notif.isRead"
          :last="i == notifications.length - 1"
          flex="true"
          @click.native="viewNotification(notif)"
          >{{ $t(`${notif.content}`, notif.contentValues) }}</ListItem
        >
        <ListItem
          v-else
          :highlighted="true"
          flex="true"
          :last="i == notifications.length - 1"
          @click.native="viewNotification(notif)"
        >{{ $t(`${notif.content}`, notif.contentValues) }}</ListItem>
      </div>
    </div>

    <div v-else>
      <div class="display-message">
        <img :src="require('@/assets/icons/bell-filled.svg')" alt="Bell icon" />
        <p>{{ $t("app.notifications.not-found") }}</p>
      </div>
    </div>
  </v-container>
</template>

<script>
import { neoparentUsers } from "@/api";
import { getNotifications } from "@/helpers";

export default {
  name: "neoparent-notifications",
  data() {
    return {
      notifications: []
    };
  },
  mounted() {
    getNotifications()
      .then(result => {
        this.consoleLog(result);
        this.notifications = result.data.notifications;
      })
      .catch(err => {
        this.consoleLog(err);
      });
  },
  methods: {
    viewNotification(notification) {
      neoparentUsers
        .setNotificationRead(notification.id)
        .then(result => {
          if (result.data.notification.post) {
            this.redirect(`/?highlight=${result.data.notification.post.id}`);
          }

          notification.isRead = true
        })
        .catch(err => {
          this.consoleLog(err);
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
